import { render } from "./CustomizationSaveDialog.vue?vue&type=template&id=b4cd08ee"
import script from "./CustomizationSaveDialog.vue?vue&type=script&lang=js"
export * from "./CustomizationSaveDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__